export default "__VITE_ASSET__BEjZti4B__"